import { trace } from 'rytm-helpers'
import Controller from './Controller'
import Chart  from 'chart.js/auto'
import { remToPx } from './../shared/affix-fafix'
import { subscribeScroll, unsubscribeScroll } from '../scroll'

class ModstatsController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    subscribeScroll("modstats", this.onLocomotiveScroll.bind(this))
  }
  addEventListeners() {
    super.addEventListeners()
    // this.scrollToCurrentDate()
  }
  removeEventListeners() {
    super.removeEventListeners()
    unsubscribeScroll("modstats")
  }

  /**
   * OWN
  */
  onLocomotiveScroll = (args) => {
    const list = this.getCharts()
    list.forEach(this.checkChartStatus)
  }
  checkChartStatus = (el, index) => {
    if (el.classList.contains("is-inview")) {
      if (!el.classList.contains("chart-initiated")) {
        el.classList.add("chart-initiated")
        this.initChart(el, index)
      }
    } else {
      if (el.classList.contains("chart-initiated")) {
        el.classList.remove("chart-initiated")
        this.destroyChart(el, index)
      }
    }
  }

  getCharts() {
    const container = document.querySelector(this.getContainerSelector())
    return container ? [...container.querySelectorAll(".entity .chart")] : []
  }
  initCharts() {
    const list = this.getCharts()
    list.forEach(this.initChart.bind(this))
  }
  initChart(el, index) {
    const canvas = el.querySelector("canvas")
    if (canvas) {      
      let num = el.dataset.perc ? el.dataset.perc : 0
      num = num < 100 ? num : 100
      const data = {
        datasets: [{
          data: [num, (100-num)],
          backgroundColor: [
            '#2D5FA8', '#DEDEDE'
          ],
        }],
      }
      const options = {
        rotation: 0,
        interaction: false,
        events: [], // disable interactions
        offset: 0,
        cutout: remToPx(4.3),
        animation: {
          duration: 4000,
          easing: 'easeOutQuart',
        }
      }
      const config = {
        type: 'doughnut',
        data,
        options
      }
      const chart = new Chart(canvas, config)
      
    }
  }
  destroyChart(el, index) {
    const canvas = el.querySelector("canvas")
    if (canvas) {
      const chart = Chart.getChart(canvas);
      chart.destroy()
    }
  }

}

export default ModstatsController;